/**
 * Fælles logik så vi ikke oversætter rig knockout-/finale-data med et tomt eller stale
 * server-svar (samme problem som i CL admin efter refresh).
 */

export function countKnockoutWinners(realResults) {
  if (!realResults) return 0;
  let n = 0;
  const add = (arr) => {
    if (Array.isArray(arr)) {
      arr.forEach((m) => {
        if (m?.winner) n += 1;
      });
    }
  };
  add(realResults.playoffResults);
  add(realResults.roundOf16Results);
  add(realResults.quarterFinalResults);
  add(realResults.semiFinalResults);
  if (realResults.finalResult?.winner) n += 1;
  return n;
}

/**
 * @param {object|null|undefined} newRealResults — fra seneste API-svar
 * @param {object|null|undefined} previousRealResults — eksisterende state (lokal/Redux)
 * @returns {boolean} true = brug ikke newRealResults som erstatning (behold previous)
 */
export function shouldRejectEmptierServerRealResults(newRealResults, previousRealResults) {
  const prev = countKnockoutWinners(previousRealResults);
  const next = countKnockoutWinners(newRealResults);
  return next < prev && prev > 0;
}
